import { GenericPage } from "./generic-page";


/**
 * This is a link to the very version of old order-history, which can be seen only on CoursesU
 * They currently want us to maintain it only because we don't have an url pointing to the order-history directly and apparently CoursesU links
 * to the recap page when sending confirmation mails for orders which contain recipes
 * Until they can't link to the new order history they want us to maintain the recap page
 */

const PAGE_TEMPLATE = `
<div class="miam-recap-page__main__container">
  <div class="miam-recipes-page__header">
    <div id="catalogButton" class="miam-recipes-page__tab">
      Recettes
    </div>
    <div id="recipeRecapButton" class="miam-recipes-page__tab miam-recipes-page__tab__curent">
      Mes repas
    </div>
  </div>
  <div class="miam-recap-page__sub__container">
    <div class="miam-recap-page__sub__container__left">
      <div class="miam-recap-page__left__header ">
        <h1 id='recapPageLeftHeader'>
        </h1>
      </div>
      <div class="miam-recap-page__left__recipe__block">
        <p id="previewBlockHeader" class="miam-recap-page__recipe__block__header">
          Vous avez sélectionné <span id="nbOfMeals"></span> repas. <br />
          On y jette un dernier petit coup d'oeil ?
        </p>
        <webc-miam-basket-preview-block></webc-miam-basket-preview-block>
      </div>
      <div class="miam-recap-page__left__button__raw">
        <div class="miam-recap-page__raw__continue__button">
          <span id="continueButton">
            Continuer mes achats
          </span>
        </div>
        <button class="miam-recap-page__raw__remove__all__button">
          <span id="removeAllButton">
            Retirer tous les repas
          </span>
        </button>
      </div>
    </div>
    <div class="miam-recap-page__sub__container__right">
      <div class="miam-recap-page__right__card">
        <h3 class="miam-recap-page__right__card__header">
          Récapitulatif des repas
        </h3>
        <hr class="miam-recap-page__right__card__divider">
        <p id="rightCardStats" class="miam-recap-page__right__card__stats">
        </p>
        <div class="miam-recap__card__comfirm_raw">
          <button id="confirmOrderButton">
            <span id="confirmOrderText">OK, voir mon panier</span>
          </button>
        </div>
        <!-- <p id="rightCardFooter" class="miam-recap__right__card__footer"></p> -->
      </div>
    </div>
  </div>
`;

export class RecapPage extends GenericPage {
  _homeRoute;
  _basketRoute;
  _header;
  _footer;

  /**
   * @param {string} homeRoute route to navigate on click on continue shopping
   * @param {string} basketRoute  route to navigate on click on go to basket
   * @param {Array<{id: string, route: string}} buttonList list of available miam button on retailer
   */
  constructor(
    routeWrapper,
    homeRoute,
    basketRoute,
    { buttonList = null, header = null, footer = null } = null
  ) {
    super(routeWrapper, PAGE_TEMPLATE, buttonList);
    this._header = header;
    this._footer = footer;
    this._homeRoute = homeRoute;
    this._basketRoute = basketRoute;
    this._initBasketSubscription();
  }

  /**
   * Each time miam basket change update reicpe page
   */
  _initBasketSubscription() {
    window.mealz.basket.recipeCount().subscribe((recipeCount) => {
      this._refreshRecipeRecapFragmentView(recipeCount);
    });
  }

  /**
   * Call each time recipeCount changed and on load
   * @param {recipesCount, entriesCount, totalPrice } recipeCount
   */
  _refreshRecipeRecapFragmentView(recipeCount) {
    if (
      !this._domFragment?.firstElementChild?.getElementsByClassName(
        "miam-recap-page__main__container"
      )
    )
      return;
    const previewBlockHeader =
      this._domFragment.getElementById("previewBlockHeader");
    const leftHeader = this._domFragment.getElementById("recapPageLeftHeader");
    const rightCardStats = this._domFragment.getElementById("rightCardStats");
    const removeAllButton = this._domFragment.getElementById("removeAllButton");

    if (recipeCount > 0) {
      this._setFillState(
        recipeCount,
        previewBlockHeader,
        removeAllButton,
        leftHeader,
        rightCardStats
      );
    } else {
      this._setEmptyState(
        previewBlockHeader,
        removeAllButton,
        leftHeader,
        rightCardStats
      );
    }
  }

  /**
   * Call if there is at least one recipe in basket
   * @param {{recipesCount, entriesCount, totalPrice }} recipeCount
   * @param {DomElement} previewBlockHeader
   * @param {DomElement} removeAllButton
   * @param {DomElement} leftHeader
   * @param {DomElement} rightCardStats
   */
  _setFillState(
    recipeCount,
    previewBlockHeader,
    removeAllButton,
    leftHeader,
    rightCardStats
  ) {
    const nbOfMeals = this._domFragment.getElementById("nbOfMeals");

    previewBlockHeader.classList.remove("miam-hidden");
    removeAllButton.classList.remove("hidden");

    leftHeader.innerHTML = "Avant de passer au panier...";
    nbOfMeals.innerHTML = recipeCount;
    rightCardStats.innerHTML = `${recipeCount} repas`;
  }

  /**
   * Call if there is no recipe in basket
   * @param {DomElement} previewBlockHeader
   * @param {DomElement} removeAllButton
   * @param {DomElement} leftHeader
   * @param {DomElement} rightCardStats
   */
  _setEmptyState(
    previewBlockHeader,
    removeAllButton,
    leftHeader,
    rightCardStats
  ) {
    previewBlockHeader.classList.add("miam-hidden");
    removeAllButton.classList.add("miam-hidden");
    leftHeader.innerHTML = "Mes repas";
    rightCardStats.innerHTML = `0 repas, 0 produits`;
  }

  /**
   * Override _initButtonListeners to add specific page button
   */
  _initButtonListeners() {
    super._initButtonListeners();
    const confirmOrderButton =
      this._domFragment.getElementById("confirmOrderButton");
    const continueButton = this._domFragment.getElementById("continueButton");
    const removeAllButton = this._domFragment.getElementById("removeAllButton");
    confirmOrderButton.addEventListener(
      "click",
      () => {
        this._routeWrapper.navigate(this._basketRoute).bind(this);
      },
      false
    );
    continueButton.addEventListener(
      "click",
      () => {
        this._routeWrapper.navigate(this._homeRoute).bind(this);
      },
      false
    );
    removeAllButton.addEventListener(
      "click",
      () => {
        window.mealz.basket.reset();
      },
      false
    );
  }

  /**
   *
   * @param {DomElement} pagePlaceHolder
   */
  injectPageFragment(pagePlaceHolder) {
    if (!pagePlaceHolder) return;
    this._refreshRecipeRecapFragmentView(window.mealz.basket.recipeCount());
    this._initButtonListeners();
    if (this._header)
      pagePlaceHolder.parentElement.insertBefore(this._header, pagePlaceHolder);
    if (this._footer)
      pagePlaceHolder.parentElement.insertBefore(
        this._footer,
        pagePlaceHolder.nextSibling
      );
    pagePlaceHolder.replaceWith(this._domFragment);
  }
}
